import { isGA4Available } from './ga4.util';
import { logger } from './logger.util';

/**
 * Eventos de analytics utilizados na aplicação
 */
export const ANALYTICS_EVENTS = {
  // Eventos de navegação e visualização
  CAMPAIGN_CLICKED: 'campaign_clicked',
  CAMPAIGN_DETAIL_VIEWED: 'campaign_detail_viewed',
  CHALLENGE_DETAIL_VIEWED: 'challenge_detail_viewed',
  
  // Eventos de interação com mídias
  CHALLENGE_MEDIA_CLICKED: 'challenge_media_clicked',
  CAMPAIGN_ACTION_CLICKED: 'campaign_action_clicked',
  CAMPAIGN_PHASE_SWITCHED: 'campaign_phase_switched',
  
  // Eventos de recompensa
  SUCCESS_IMPRESSION: 'success_impression',
  COIN_REWARDED: 'coin_rewarded',
} as const;

export class AnalyticsUtil {
  /**
   * Rastreia um evento de analytics genérico
   * @param eventName Nome do evento
   * @param data Dados adicionais do evento (opcional)
   */
  static track(eventName: string, data?: Record<string, any>): void {
    // Sempre adicionar ao dataLayer, mesmo se o script ainda não carregou
    // O GA4 processará quando o script carregar
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: eventName,
        ...data,
        event_category: 'engagement',
        event_label: eventName
      });
    }
    
    // Também usar gtag se disponível (método oficial)
    if (isGA4Available() && window.gtag) {
      try {
        window.gtag('event', eventName, {
          ...data,
          event_category: 'engagement',
          event_label: eventName
        });
      } catch (error) {
        logger.error('[Analytics] Erro ao enviar evento via gtag:', error);
      }
    }
  }

  /**
   * Rastreia visualização de página
   * @param pagePath Caminho da página
   * @param pageTitle Título da página (opcional)
   */
  static trackPageView(pagePath: string, pageTitle?: string): void {
    const pageData = {
      page_path: pagePath,
      page_title: pageTitle || document.title,
      page_location: window.location.href
    };

    // Adicionar ao dataLayer
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: 'page_view',
        ...pageData
      });
    }

    // Usar gtag se disponível
    if (isGA4Available() && window.gtag) {
      try {
        // Método 1: via event
        window.gtag('event', 'page_view', pageData);
        
        // Método 2: via config (método oficial do GA4)
        const measurementId = (window as any).__gaMeasurementId;
        if (measurementId) {
          window.gtag('config', measurementId, pageData);
        }
      } catch (error) {
        logger.error('[Analytics] Erro ao enviar page_view:', error);
      }
    }
  }

  /**
   * Rastreia evento com IDs do Artemis (equivalente ao sendEventWithArtemisIds do Flutter)
   * @param eventName Nome do evento
   * @param options IDs do Artemis (campaignId, mediaId, requestId)
   */
  static trackWithArtemisIds(
    eventName: string,
    options?: {
      campaignId?: string;
      mediaId?: string;
      requestId?: string;
    }
  ): void {
    this.track(eventName, {
      campaignId: options?.campaignId,
      mediaId: options?.mediaId,
      requestId: options?.requestId
    });
  }
}

